import React, { forwardRef } from "react";
import Label from "./Label";
import ErrorMessage from "./ErrorMessage";

const Input = forwardRef(
  (
    {
      label = "",
      type = "text",
      labelClassName = "",
      inputClassName = "",
      containerClassName = "",
      error = "",
      errorMessageClassName = "",
      labelPosition = "left",
      size = "small",
      inputBoxStyle = {},
      containerStyle = {},
      ...rest
    },
    ref
  ) => {
    const commonProps = {
      type,
      ref,
      ...rest
    };

    const inputClasses = `${inputClassName} ${error ? "builder_error_inputBox" : ""}`.trim();

    let defaultContainerClasses = `form_element_wrapper_text ${size} ${labelPosition}`;

    if (["checkbox", "radio"].includes(type)) {
      defaultContainerClasses = `form_element_wrapper_radio ${size} ${labelPosition}`;
    }

    if (["checkbox", "radio"].includes(type)) {
      return (
        <div className={`${defaultContainerClasses} ${containerClassName}`} style={containerStyle}>
          <Label className={labelClassName}>
            <input {...commonProps} className={`builder_${type} ${inputClasses}`} style={inputBoxStyle} />
            <span>{label}</span>
          </Label>
          {error && <ErrorMessage className={errorMessageClassName}>{error}</ErrorMessage>}
        </div>
      );
    }

    return (
      <div className={`${defaultContainerClasses} ${containerClassName}`} style={containerStyle}>
        {label && (
          <Label className={labelClassName} htmlFor={rest.id}>
            {label}
          </Label>
        )}
        <input {...commonProps} className={`builder_input ${inputClasses}`} style={inputBoxStyle} />
        {error && <ErrorMessage className={errorMessageClassName}>{error}</ErrorMessage>}
      </div>
    );
  }
);

Input.displayName = "Input";

export default Input;
